var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deviceBorrowRemind",attrs:{"id":"deviceBorrowRemind"}},_vm._l((_vm.remindList),function(item){return _c('remind-item',{attrs:{"data-info":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }